var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/mask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M51.2634 28.5C51.2634 35.36 48.2767 41.5667 43.5167 45.79C39.41 49.5234 33.9734 51.7634 28 51.7634C15.1667 51.7634 4.73669 41.3334 4.73669 28.5C4.73669 15.6667 15.1667 5.23669 28 5.23669C33.9734 5.23669 39.41 7.47669 43.5167 11.21C48.2767 15.4334 51.2634 21.64 51.2634 28.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.93 38.7433C27.8833 42.5933 25.0133 43.5267 22.33 42.4533C16.8 40.2367 12.9033 34.8233 12.9033 28.5C12.9033 22.1767 16.8 16.7633 22.33 14.5233C25.0133 13.45 27.8833 14.4067 27.93 18.2333V38.7433Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/dark_mode_icon.9196edf97ff650a1adf31dc499cee982.svg";
export { ForwardRef as ReactComponent };